// File: src/components/Cards/AsyncProductCard.tsx

import React, { useEffect, useState } from "react";
import { getProductDetails } from "../../api";
import ProductCard from "./ProductCard";
import "./ProductCard.css"; // For loading animation styles

export const AsyncProductCard = ({
    sku,
    spinnerActive,
    benefits,
    priceSource,
    siteId
}: {
    sku: string;
    onCitationClicked?: (citationFilePath: string) => void;
    spinnerActive: boolean;
    benefits?: string | string[];
    priceSource: "web" | "store";
    siteId: "PUBLIC_GR" | "PUBLIC_CY";
}) => {
    const [product, setProduct] = useState<any | null>(null);
    const [showLoading, setShowLoading] = useState(false);
    const LOADING_INDICATOR_DELAY = 300;

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoading(true);
        }, LOADING_INDICATOR_DELAY);
        return () => clearTimeout(timer);
    }, [sku]);

    useEffect(() => {
        // The getProductDetails function now handles caching and deduplication internally
        getProductDetails(sku, siteId)
            .then(data => {
                // Merge benefits if provided
                setProduct(benefits ? { ...data, benefits } : data);
            })
            .catch(error => {
                console.error("Failed to fetch product details for SKU:", sku, error);
                // Fallback: create a basic product object with the benefits if available
                if (benefits) {
                    setProduct({
                        sku: sku,
                        sku_id: sku,
                        content: `Product ${sku}`,
                        benefits: benefits
                    });
                }
            });
    }, [sku, benefits, siteId]);

    if (!product && showLoading) {
        return spinnerActive ? (
            <div className="product-loading-container">
                <div className="product-loading-dots">
                    <span className="loading-dot"></span>
                    <span className="loading-dot"></span>
                    <span className="loading-dot"></span>
                </div>
            </div>
        ) : null;
    }

    return product ? <ProductCard product={product} priceSource={priceSource} /> : null;
};

export default AsyncProductCard;
